import styled, { css } from 'styled-components';

import ArrowButton from 'Elements/Button/Arrow';

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;

        @media ${theme.breakpoints.large.media} {
            flex-direction: row;
        }
    `}
`;

const BaseContainer = styled.div`
    ${({ theme }) => css`
        padding: 1rem 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 2.5rem 5.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 2.5rem 1.5rem;
        }
    `}
`;

export const ApplyContainer = styled(BaseContainer)`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: ${theme.colors.secondary.tints[0].hex};
        border-radius: 0.5rem 0.5rem 0 0;
        color: ${theme.colors.primary.hex};
        text-align: center;
        z-index: 2;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            text-align: left;
        }

        @media ${theme.breakpoints.large.media} {
            border-radius: 0.5rem 0 0 0.5rem;
            display: block;
            width: 60%;
        }
    `}
`;

export const InputContainer = styled.div`
    ${({ theme }) => css`
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-top: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-top: 0;
        }
    `}
`;

export const ApplyButton = styled(ArrowButton)`
    ${({ theme }) => css`
        @media ${theme.breakpoints.medium.media} {
            margin-right: inherit;
            font-size: 1.5rem;
            --icon-background-size: 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: inherit;
        }
    `}
`;

export const OpenDayContainer = styled(BaseContainer)`
    ${({ theme }) => css`
        position: relative;
        width: 100%;
        background: ${theme.colors.primary.hex};
        color: ${theme.colors.primaryContrast.hex};
        text-align: center;
        border-radius: 0 0 0.5rem 0.5rem;
        z-index: 1;

        @media ${theme.breakpoints.medium.media} {
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        @media ${theme.breakpoints.large.media} {
            flex-direction: column;
            width: 40%;
            border-radius: 0 0.5rem 0.5rem 0;
        }
    `}
`;

export const Inner = styled.div`
    position: relative;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            font-size: 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const OpenDayButton = styled(ArrowButton)`
    ${({ theme }) => css`
        && {
            color: ${theme.colors.primary.hex};
            margin-top: 0.5rem;

            &&:hover {
                color: ${theme.colors.primary.hex};
            }

            @media ${theme.breakpoints.medium.media} {
                margin: 0 0 0 1.5rem;
                font-size: 1.5rem;
                --icon-background-size: 2rem;
            }

            @media ${theme.breakpoints.large.media} {
                margin: 0;
                font-size: inherit;
            }
        }
    `}
`;

export const WaveWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: -1;
`;

export const WaveApplication = styled.div`
    ${({ theme }) => css`
        position: absolute;
        top: 30%;
        bottom: 0;
        right: 0;
        left: 0;
        border-radius: 0.5rem 0.5rem 0 0;

        @media ${theme.breakpoints.large.media} {
            transform: translateY(-50%);
            top: 50%;
            right: 0;
            left: 0;
            bottom: unset;
            height: 100%;
        }
    `}
`;

export const WaveOpenDay = styled.div`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;

        @media ${theme.breakpoints.large.media} {
            transform: translateY(-50%);
            top: 55%;
            height: 100%;
            right: 0;
            left: 0;
        }
    `}
`;
